import { render, staticRenderFns } from "./RelativeProfileConfirm.vue?vue&type=template&id=05bc0174&scoped=true&"
import script from "./RelativeProfileConfirm.vue?vue&type=script&lang=ts&"
export * from "./RelativeProfileConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./RelativeProfileConfirm.vue?vue&type=style&index=0&id=05bc0174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bc0174",
  null
  
)

export default component.exports